import { render, staticRenderFns } from "./SearchPreview.vue?vue&type=template&id=3a3fccf4"
import script from "./SearchPreview.vue?vue&type=script&lang=js"
export * from "./SearchPreview.vue?vue&type=script&lang=js"
import style0 from "./SearchPreview.vue?vue&type=style&index=0&id=3a3fccf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports